import React from 'react';

const ItemList = ({
  items = [],
  onItemSelect,
  searchQuery,
  onSearch,
  currentPage,
  onPageChange,
  totalPages,
  isLoading,
  error,
}) => {
  const handleSearchChange = (e) => {
    onSearch(e.target.value);
  };

  return (
    <div className="p-4 space-y-4">
      {/* Search Bar */}
      <input
        type="text"
        placeholder="Search by name..."
        value={searchQuery}
        onChange={handleSearchChange}
        className="w-full px-4 py-2 border rounded-lg shadow-sm"
      />

      {/* Item List */}
      {isLoading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : (
        <div className="relative max-h-[600px]">
          <div
            className={`grid grid-cols-1 gap-4 overflow-y-auto transition-all max-h-[500px] pr-2 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100`}
            style={{
              scrollBehavior: 'smooth',
              paddingRight: '6px',
            }}
          >
            {items.map((item, index) => (
              <div
                key={index}
                onClick={() => onItemSelect(item)}
                className="cursor-pointer p-4 border rounded-xl shadow hover:shadow-md transition bg-white"
              >
                <h3 className="text-lg font-semibold mb-2 break-words">
                  {item.title}
                </h3>
                {/* <p className="text-[#4F23A9] font-medium text-base">
                  Price: {item.price}
                </p> */}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex justify-center gap-2 pt-4">
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i}
              onClick={() => onPageChange(i + 1)}
              className={`px-3 py-1 rounded-lg border ${
                currentPage === i + 1
                  ? 'bg-[#4F23A9] text-white'
                  : 'bg-white text-black'
              }`}
            >
              {i + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ItemList;
